import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { ConfigProvider } from './contexts/ConfigContext'
import { DataProvider } from './contexts/DataContext'
import { LocationProvider } from './contexts/LocationContext'
import { FilterProvider } from './contexts/FilterContext'
import { ViewProvider } from './contexts/ViewContext'
import Layout from './components/layout/Layout'
import Dashboard from './views/Dashboard'
import DatasetsPage from './views/DatasetsPage'
import * as echarts from 'echarts'

echarts.registerTheme('ug-dashboard', {
  color: [
    '#ef233c',
    '#c10e66',
    '#7f2a74',
    '#3b2f65',
    '#0b2440',
    '#10b981',
    '#f59e0b',
    '#8b5cf6',
    '#06b6d4',
    '#f97316',
    '#84cc16',
    '#ec4899',
    '#6b7280',
  ],
  backgroundColor: '#fff',
  textStyle: { fontFamily: 'Poppins, system-ui, sans-serif' },
})

function App() {
  return (
    <Router>
      <ConfigProvider>
        <DataProvider>
          <LocationProvider>
            <FilterProvider>
              <ViewProvider>
                <Layout>
                  <Routes>
                    <Route
                      path="/"
                      element={<Navigate to="/dashboard" replace />}
                    />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/dashboard/:view" element={<Dashboard />} />
                    <Route path="/datasets" element={<DatasetsPage />} />
                  </Routes>
                </Layout>
              </ViewProvider>
            </FilterProvider>
          </LocationProvider>
        </DataProvider>
      </ConfigProvider>
    </Router>
  )
}

export default App
